import React from "react";

export default function SmAnimatespin() {
  return (
    <div className="flex items-center justify-center w-full">
      <div className="w-4 h-4 border border-secondary border-dashed rounded-full animate-spin"></div>
    </div>
  );
}
